import { menuItems } from "../../data/menu";
import { Link, useLocation } from "react-router-dom";

export default function Nav() {
  const { pathname } = useLocation();

  return (
    <>
      {/* {menuItems.map((item, index) => (
        <li
          key={index}
          className={`dropdown2 ${item.links.some(
            (el) => el.href.split("/")[1] == pathname.split("/")[1]
          )
              ? "current"
              : ""
            }`}
        >
          <a>{item.title}</a>
          <ul>
            {item.links.map((link, linkIndex) => (
              <li
                key={linkIndex}
                className={
                  link.href.split("/")[1] == pathname.split("/")[1]
                    ? "current"
                    : ""
                }
              >
                <Link to={link.href}>{link.label}</Link>
              </li>
            ))}
          </ul>
          <div className="dropdown2-btn"></div>
        </li>
      ))} */}

      <li className={`${("/".split("/")[1] == pathname.split("/")[1])
        ? "current"
        : ""
        }`} >
        <Link to="/">Home</Link>
      </li>
      {/* <li className={`${("/aboutus".split("/")[1] == pathname.split("/")[1])
        ? "current"
        : ""
        }`}>
        <Link
          to="/about-us"
        >About Us</Link>
      </li> */}
      <li className={`${("/blog-grid".split("/")[1] == pathname.split("/")[1])
        ? "current"
        : ""
        }`}>
        <Link to="/blog-grid">Blog</Link>
      </li>
      {/* <li className={`${("/allproperties".split("/")[1] == pathname.split("/")[1])
        ? "current"
        : ""
        }`} >
        <Link to="/allproperties">Properties</Link>
      </li> */}
      <li           >
        <Link to="/our-services">Our Services</Link>
      </li>
      {/* <li className={`dropdown2`}>
        <a>View All</a>
        <ul>
          <li>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </li>
        </ul>
        <div className="dropdown2-btn"></div>
      </li> */}

      {/* <li>
        <Link to="/faq">FAQs</Link>
      </li> */}
      <li  >
        <Link to="/contact-us">Contact Us</Link>
      </li>
    </>
  );
}
